import { rules } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const iconTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function CommunityRules() {
  return (
    <section id="rules" className="w-full py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="社区规范"
          title="互动开放，但有几条线不能踩"
          desc="讨论氛围靠大家一起维持。下面四条是黑料社区所有用户共同遵守的基本规则，违反的内容会被折叠、下线或限制账号。"
        />

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {rules.map((rule, index) => (
            <div
              key={rule.title}
              className={`animate-fade-up flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 ${
                index % 2 === 1 ? "delay-100" : ""
              }`}
            >
              <span
                className={`w-10 h-10 shrink-0 rounded-md flex items-center justify-center ${
                  iconTone[rule.tone] ?? iconTone.primary
                }`}
              >
                <i className={`${rule.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {rule.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {rule.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}